/* eslint-disable @next/next/no-img-element */
"use client";

import { TPostLink, TPostMedia } from "@/types/post";
import FeedMediaCarouselUi from "./feed-post-carousel-ui";
import { useState } from "react";
import { FeedMediaCarouselModal } from "./feed-image-carousel-modal";

type FeedPostCarouselProps = {
	images: TPostMedia[];
	links: TPostLink[];
	className?: string;
	fullScreen?: boolean;
};

const FeedMediaCarousel = ({ links, images, className, fullScreen }: FeedPostCarouselProps) => {
	const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

	return (
		<>
			<FeedMediaCarouselUi
				links={links}
				images={images}
				className={className}
				fullScreen={fullScreen}
				onImageClick={(i) => setSelectedImageIndex(i)}
			/>
			{selectedImageIndex !== null && (
				<FeedMediaCarouselModal
					links={links}
					items={images}
					onCloseModal={() => setSelectedImageIndex(null)}
					selectedItemIndex={selectedImageIndex}
				/>
			)}
		</>
	);
};

export default FeedMediaCarousel;
